var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigtokens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Token"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5285 24C11.8841 24 11.2451 23.8274 10.6788 23.5039L3.84634 19.5591C3.8059 19.5376 3.76545 19.5106 3.72501 19.4863L3.66839 19.4513C2.61412 18.7556 1.99127 17.6016 1.99127 16.3559V7.64678C1.99127 6.32828 2.70041 5.10145 3.83826 4.44624L10.6761 0.49882C11.2343 0.172565 11.876 0 12.5285 0H12.5582C13.1999 0.00539265 13.8281 0.175261 14.3782 0.49882L21.2161 4.44624C22.3566 5.10145 23.0631 6.32828 23.0631 7.64678V16.3532C23.0631 17.6717 22.3539 18.8985 21.2161 19.5538L14.3755 23.5039C13.812 23.8301 13.1729 24 12.5285 24ZM12.5285 1.6178C12.1618 1.6178 11.8032 1.71486 11.4904 1.89821L4.64715 5.84833C4.00543 6.21773 3.60907 6.90529 3.60907 7.64678V16.3532C3.60907 17.0543 3.95959 17.7041 4.54469 18.0897C4.54469 18.0897 4.62289 18.1382 4.64446 18.149L11.4904 22.1018C11.8086 22.2851 12.1699 22.3822 12.5312 22.3822C12.8925 22.3822 13.2511 22.2851 13.5693 22.1018L20.4099 18.1517C21.0516 17.7823 21.448 17.0947 21.448 16.3532V7.64678C21.448 6.90529 21.0516 6.21773 20.4099 5.84833L13.5693 1.89821C13.2592 1.71756 12.9087 1.62049 12.5501 1.6178L12.5312 1.21335V1.6178H12.5285Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5519 1.21515C12.9698 1.21784 13.3931 1.32839 13.7706 1.54949L20.6112 5.49961C21.3797 5.94181 21.8515 6.76149 21.8515 7.64858V16.355C21.8515 17.2421 21.3797 18.0618 20.6112 18.504L13.7706 22.4541C13.3877 22.6752 12.9563 22.7885 12.5303 22.7885C12.1043 22.7885 11.6729 22.6752 11.2873 22.4541L4.44673 18.504C4.40359 18.4797 4.36314 18.4528 4.3227 18.4285C3.62705 17.9701 3.20642 17.1936 3.20642 16.355V7.64858C3.20642 6.76149 3.67828 5.94181 4.44673 5.49961L11.2873 1.54949C11.6702 1.3257 12.1016 1.21515 12.5303 1.21515H12.5519ZM12.5519 0.40625H12.5276C11.9452 0.40625 11.3736 0.559941 10.8775 0.851144L4.04228 4.79857C3.02846 5.38097 2.39752 6.47298 2.39752 7.64858V16.355C2.39752 17.4659 2.95027 18.4932 3.8778 19.1053L3.89129 19.1134L3.90477 19.1215L3.93712 19.143C3.97218 19.1646 4.00992 19.1889 4.04767 19.2104L10.8802 23.1552C11.3871 23.4464 11.956 23.5974 12.5276 23.5974C13.0992 23.5974 13.6709 23.4437 14.1724 23.1552L21.013 19.205C22.0268 18.6226 22.6577 17.5306 22.6577 16.355V7.64858C22.6577 6.47568 22.0268 5.38367 21.013 4.79857L14.1751 0.848448C13.687 0.562637 13.1262 0.408946 12.5573 0.40625H12.5519Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.8512 7.64437V16.3508C21.8512 17.2379 21.3794 18.0576 20.6109 18.4998L13.7703 22.4499C13.3874 22.671 12.956 22.7842 12.53 22.7842C12.104 22.7842 11.6726 22.671 11.287 22.4499L4.44643 18.4998C4.40328 18.4755 4.36284 18.4486 4.32239 18.4243C3.62674 17.9659 3.20612 17.1894 3.20612 16.3508V7.64437C3.20612 6.75728 3.67797 5.9376 4.44643 5.4954L11.287 1.54528C11.6699 1.32149 12.1013 1.21094 12.53 1.21094H12.5516C12.9695 1.21363 13.3928 1.32418 13.7703 1.54528L20.6109 5.4954C21.3794 5.9376 21.8512 6.75728 21.8512 7.64437Z",
    fill: "url(#paint0_linear_900_135578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.15,
    d: "M12.5288 22.7917L18.6764 16.3717L21.85 8.72223L12.5234 3.82031L3.20221 8.72223L6.38118 16.3717L12.5288 22.7917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.15,
    d: "M6.38239 16.3682L4.32239 18.4282C3.62674 17.9698 3.20612 17.1933 3.20612 16.3547V8.71875L6.38239 16.3682Z",
    fill: "url(#paint1_linear_900_135578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.15,
    d: "M18.6749 16.3682L20.7349 18.4282C21.4305 17.9698 21.8511 17.1933 21.8511 16.3547V8.71875L18.6749 16.3682Z",
    fill: "url(#paint2_linear_900_135578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.15,
    d: "M21.8476 7.64437V8.71481L12.5264 3.81289V1.21094H12.548C12.9659 1.21363 13.3893 1.32418 13.7667 1.54528L20.6073 5.4954C21.3758 5.9376 21.8476 6.75728 21.8476 7.64437Z",
    fill: "url(#paint3_linear_900_135578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.15,
    d: "M3.20612 7.64437V8.71481L12.5273 3.81289V1.21094H12.5057C12.0878 1.21363 11.6645 1.32418 11.287 1.54528L4.44643 5.4954C3.67797 5.9376 3.20612 6.75728 3.20612 7.64437Z",
    fill: "url(#paint4_linear_900_135578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.15,
    d: "M12.527 22.7871C12.0956 22.7871 11.6696 22.6739 11.284 22.4528L4.44343 18.5027C4.40029 18.4784 4.35984 18.4514 4.3194 18.4272L6.37939 16.3672L12.527 22.7871Z",
    fill: "url(#paint5_linear_900_135578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.15,
    d: "M12.5264 22.7871C12.9578 22.7871 13.3839 22.6739 13.7694 22.4528L20.61 18.5027C20.6532 18.4784 20.6936 18.4514 20.734 18.4272L18.6741 16.3672L12.5264 22.7871Z",
    fill: "url(#paint6_linear_900_135578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M14.6548 10.1824L16.7174 11.3095C17.2621 11.6061 17.2621 12.388 16.7174 12.6846L14.6548 13.8116C14.5226 13.8844 14.4148 13.9923 14.342 14.1244L13.2149 16.1871C12.9183 16.7318 12.1364 16.7318 11.8398 16.1871L10.7127 14.1244C10.6399 13.9923 10.5321 13.8844 10.4 13.8116L8.33727 12.6846C7.79261 12.388 7.79261 11.6061 8.33727 11.3095L10.4 10.1824C10.5321 10.1096 10.6399 10.0017 10.7127 9.86962L11.8398 7.80693C12.1364 7.26227 12.9183 7.26227 13.2149 7.80693L14.342 9.86962C14.4148 10.0017 14.5226 10.1096 14.6548 10.1824Z",
    fill: "url(#paint7_linear_900_135578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.1,
    d: "M8.33602 12.0887L10.3987 10.9616C10.5308 10.8888 10.6387 10.781 10.7115 10.6489L11.8385 8.58617C12.1351 8.04151 12.9171 8.04151 13.2137 8.58617L14.3407 10.6489C14.4135 10.781 14.5214 10.8888 14.6535 10.9616L16.7162 12.0887C16.851 12.1642 16.9535 12.2667 17.0209 12.388C17.2258 12.0294 17.1233 11.5333 16.7162 11.3095L14.6535 10.1824C14.5214 10.1096 14.4135 10.0017 14.3407 9.86962L13.2137 7.80693C12.9171 7.26227 12.1351 7.26227 11.8385 7.80693L10.7115 9.86962C10.6387 10.0017 10.5308 10.1096 10.3987 10.1824L8.33602 11.3095C7.92887 11.5333 7.82641 12.0267 8.03133 12.388C8.09874 12.2694 8.2012 12.1642 8.33602 12.0887Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.6,
    d: "M12.5275 1.21094L12.2686 3.94771L12.5275 3.81289L12.7863 3.94771L12.5275 1.21094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.6,
    d: "M20.737 18.4252L18.7849 16.1172L18.6797 16.3653L18.4991 16.5513L20.737 18.4252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.6,
    d: "M4.3194 18.4252L6.27154 16.1172L6.37669 16.3653L6.55735 16.5513L4.3194 18.4252Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_900_135578",
    x1: 2.76122,
    y1: 2.23015,
    x2: 28.2038,
    y2: 27.6727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#DD6B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#805AD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_900_135578",
    x1: 0.71471,
    y1: 15.3814,
    x2: 6.67898,
    y2: 11.8465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_900_135578",
    x1: 24.6472,
    y1: 15.7238,
    x2: 18.5994,
    y2: 11.8465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_900_135578",
    x1: 18.7522,
    y1: 0.539552,
    x2: 15.9885,
    y2: 8.34811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_900_135578",
    x1: 10.5967,
    y1: 7.69291,
    x2: 5.68404,
    y2: 2.7829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_900_135578",
    x1: 4.3194,
    y1: 19.5785,
    x2: 12.527,
    y2: 19.5785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_900_135578",
    x1: 21.516,
    y1: 19.5785,
    x2: 11.7472,
    y2: 19.5785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_900_135578",
    x1: 12.5274,
    y1: 4.63336,
    x2: 12.5274,
    y2: 16.5835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6B46C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#553C9A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigtokens);
export default __webpack_public_path__ + "static/media/Bigtokens.9db1cad92acc7fd8bd3c3af52ccf0262.svg";
export { ForwardRef as ReactComponent };